/* MrRizz — hledání na stránce písmene.

   Každé písmeno má vlastní stránku a vykreslí se celé ze serveru, takže tady
   se nic nedonačítá – filtruje se jen to, co už na stránce je. */
(() => {
  const norm = (value) =>
    (value || '')
      .toLowerCase()
      /* Diakritika pryč, ať „Hermès“ najde i „hermes“. */
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();

  const setup = (root) => {
    if (!root || root.dataset.brandDirReady === '1') return;
    root.dataset.brandDirReady = '1';

    const input = root.querySelector('[data-brand-dir-search]');
    if (!input) return;

    const items = Array.from(root.querySelectorAll('.brand-dir__item'));
    const empty = root.querySelector('[data-brand-dir-empty]');

    /* Klíče si připravíme jednou dopředu – při stovkách značek se nevyplatí
       normalizovat text na každé stisknutí klávesy. */
    const haystack = items.map((item) => norm(item.dataset.brandSearch));

    const apply = () => {
      const q = norm(input.value);
      let visible = 0;

      items.forEach((item, i) => {
        const hit = q === '' || haystack[i].includes(q);
        item.hidden = !hit;
        if (hit) visible += 1;
      });

      if (empty) empty.hidden = visible !== 0;
    };

    let timer = null;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(apply, 90);
    });

    /* Enter nemá odesílat nadřazený formulář, kdyby nějaký byl. */
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') event.preventDefault();
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-brand-dir]').forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
